<template>
  <div class="ub ub-ac">
    <!--提交审批按钮-->
    <submit-approval-btn
      v-model:loading="loading"
      @refresh="refreshApprovalDetail"
      :biz-type="bizType"
      :biz-id="bizId"
      :biz-name="bizName"
      v-if="showSubmitFlg"
      class="margin-left-14px"
    />
    <!--同意按钮-->
    <agree-btn
      v-model:loading="loading"
      @refresh="refreshApprovalDetail"
      :biz-type="bizType"
      :biz-id="bizId"
      v-if="showAgreeFlg"
      class="margin-left-14px"
    />
    <!--拒绝按钮-->
    <reject-btn
      v-model:loading="loading"
      @refresh="refreshApprovalDetail"
      :biz-type="bizType"
      :biz-id="bizId"
      v-if="showRejectFlg"
      class="margin-left-14px"
    />
    <!--撤销按钮-->
    <cancel-btn
      v-model:loading="loading"
      @refresh="refreshApprovalDetail"
      :biz-type="bizType"
      :biz-id="bizId"
      v-if="showCancelFlg"
      class="margin-left-14px"
    />
    <!--作废按钮-->
    <template v-if="!notShowVoid">
      <void-btn
        v-model:loading="loading"
        @refresh="refreshApprovalDetail"
        :biz-type="bizType"
        :biz-id="bizId"
        :biz-name="bizName"
        class="margin-left-14px"
        v-if="showVoidBtn && !existRelation && !disabledVoid"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, reactive, toRefs, ref, PropType, watch } from "vue";
import { ApprovalFlowService } from "./approval-flow.service";
import SubmitApprovalBtn from "./components/submit-approval-btn.vue";
import AgreeBtn from "./components/agree-btn.vue";
import RejectBtn from "./components/reject-btn.vue";
import CancelBtn from "./components/calcel-btn.vue";
import VoidBtn from "./components/void-btn.vue";
import { message } from "ant-design-vue";
import { getCurrentUserId } from "@/utils";
import { useFlowEmitter } from "@/utils/emitter";
import { useStore } from "@/store";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
export default defineComponent({
  isGlobal: true,
  name: "ApprovalFlowBtn",
  components: {
    SubmitApprovalBtn,
    AgreeBtn,
    RejectBtn,
    CancelBtn,
    VoidBtn,
  },
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    record: {
      type: Object as PropType<any>,
    },
    // 接口需要
    bizName: {
      type: String,
      required: true,
    },
    // 创建人id
    createBy: {
      type: String,
    },
    flowStatus: {
      type: String,
    },
    validStatus: {
      type: String,
      required: true,
    },
    flowType: {
      type: String,
    },
    noVoidFlow: {
      type: Boolean,
      default: false,
    },
    showEditBtn: {
      type: Boolean,
    },
    disabledVoid: {
      type: Boolean,
      default: false,
    },
    notVoid: {
      type: Boolean,
    },
    eventName: {
      type: String,
    },
    examineAccess: {
      type: String,
    },
  },
  emits: [
    "reloadFlowStatus",
    "resetStatus",
    "update:flowStatus",
    "update:flowType",
    "update:showEditBtn",
    "refreshApprovalDetail",
  ],
  setup(props, { emit }) {
    const store = useStore();
    const { emitEvent } = useFlowEmitter();
    let existRelation = ref(false);
    const state = reactive(<
      {
        flowStatus: string;
        flowType: string;
        currentUserId: string;
        auditUsers: string[];
        createBy: string | undefined;
        loading: boolean;
        invalid: number;
      }
    >{
      flowStatus: "",
      flowType: "",
      currentUserId: getCurrentUserId(),
      auditUsers: [],
      createBy: "",
      loading: false,
      invalid: 0,
    });

    // 明确无作废按钮的流程
    // 工程合同变更、采购申请、采购订单、收货单、入库单、领料单、退料单、出库单、其他入库单、其他出库单、采购合同结算单、采购合同变更、借印申请
    const notShowVoid = computed(() => {
      const arr = [
        "contract_change_examine",
        "purchase_apply_examine",
        "purchase_order_examine",
        "purchase_receive_order_examine",
        "put_storage_receipts",
        "receive_material",
        "return_material",
        "take_out_receipts",
        "other_put_storage_receipts",
        "other_take_out_receipts",
        "purchase_contract_settle",
        "purchase_contract_change_examine",
        "borrow_seal_examine",
      ];
      if (arr.some((o) => o === props.bizType)) {
        return true;
      }
      return false;
    });

    //
    // 待提交        提交审批，编辑
    // 审批中    tjsp  同意，拒绝，撤销
    // 审批中    yzf    同意，拒绝，撤销
    // 审批通过  tjsp  作废
    // 审批通过  yzf    无操作按钮
    // 审批驳回  tjsp  提交审批，编辑
    // 审批驳回  yzf    作废
    // 已撤销    tjsp  编辑，提交审批
    // 已撤销    yzf    作废
    //
    // tjsp：提交审批流程
    // yzf：作废流程

    const showSubmitBtn = computed(() => {
      // console.log(getCurrentUserId(), state.flowStatus, state.flowType,  state.createBy ,'-------');
      return (
        state.createBy === getCurrentUserId() &&
        (state.flowStatus === "dtj" ||
          (state.flowStatus === "ycx" && state.flowType === "tjsp") ||
          (state.flowStatus === "spbtg" && state.flowType === "tjsp"))
      );
    });
    watch(
      () => showSubmitBtn.value,
      (n, o) => {
        emit("update:showEditBtn", n);
      },
      {
        immediate: true,
      }
    );
    watch(
      () => state.flowStatus,
      (n, o) => {
        emit("update:flowStatus", n);
      },
      {
        immediate: true,
      }
    );
    watch(
      () => state.flowType,
      (n, o) => {
        emit("update:flowType", n);
      },
      {
        immediate: true,
      }
    );
    const showAgreeBtn = computed(() => {
      return state.flowStatus === "spz" && state.auditUsers.includes(state.currentUserId);
    });

    const showRejectBtn = computed(() => {
      return state.flowStatus === "spz" && state.auditUsers.includes(state.currentUserId);
    });

    const showCancelBtn = computed(() => {
      return state.flowStatus === "spz" && state.createBy == state.currentUserId;
    });

    const showVoidBtn = computed(() => {
      //判断关联条件改为该保证金支付单下有已生效或者未生效，即非作废的保证金退回单，则不允许作废
      //只有保证金页面才调用这个接口,只有保证金下才判断invalid,invalid=0不可作废，invalid=1可作废

      //已被对外付款单关联的采购付款申请应该不可作废
      let isTrue = state.createBy === state.currentUserId;
      if (props.bizType == "purchase_payment_apply_examine") {
        isTrue = isTrue && state.invalid == 1;
      }
      isTrue = isTrue && !props.notVoid;
      return (
        isTrue &&
        ((state.flowStatus === "sptg" && state.flowType === "tjsp" && !props.noVoidFlow) ||
          (state.flowStatus === "spbtg" && state.flowType === "yzf") ||
          (state.flowStatus === "ycx" && state.flowType === "yzf"))
      );
    });

    const { data: detail, run: runDetail } = ApprovalFlowService.useDetailApi();
    const { data: detail2, run: runDetail2 } = ApprovalFlowService.existRelationOrNot();
    const { data: detail3, run: runDetail3 } = ApprovalFlowService.existAssuringRelationOrNot();
    const { data: detail4, run: runDetail4 } =
      ApprovalFlowService.existAssuringReturnRelationOrNot();
    // const { data: detail5, run: runDetail5 } = ApprovalFlowService.existPaymentPage(); //根据付款合同id查询对应的对外付款单
    // const { data: detail5, run: runDetail5 } = ApprovalFlowService.existRelationOrNot(); //根据付款合同id查询对应的对外付款单

    //刷新审核组件
    const refreshApprovalDetail = async () => {
      //刷新审核组件接口
      await getDetail(false);
      //审核状态变更了，通知列表刷新数据
      emitEvent({ eventName: props.eventName });
      emit("refreshApprovalDetail", "");
    };
    const getDetail = async (isMounted = false) => {
      const { bizId, bizType } = props;
      let res = await runDetail({ bizId, bizType });
      if (res.respCode === "0000" && detail.value) {
        const { flowStatus, flowType, auditUsers, createBy, invalid } = detail.value;
        // console.log("detail.value", detail.value);
        state.flowStatus = flowStatus;
        // if( props.bizType == "purchase_apply_examine"){
        //   state.flowStatus = props.record?.purchaseApplyResp?.flowStatus;
        //   // console.log("🚀 ~ file: index.vue ~ line 291 ~ getDetail ~ state.flowStatus ", state.flowStatus )
        // }
        state.auditUsers = auditUsers;
        state.createBy = createBy ? createBy : props.createBy;
        state.flowType = flowType;
        state.invalid = invalid;
      }
    };
    //判断关联条件改为该保证金支付单下有已生效或者未生效，即非作废的保证金退回单，则不允许作废
    //只有保证金页面才调用这个接口
    const existRelationOrNot = async () => {
      existRelation.value = true;
      const { bizId, bizType } = props;
      let res = await runDetail2(bizId);
      if (res.respCode === "0000" && detail2.value) {
        existRelation.value = detail2.value.count > 0;
      } else {
        // message.error(res.respDesc);
      }
    };
    const existassuringRelationOrNot = async () => {
      const { bizId, bizType } = props;
      let res = await runDetail3(bizId);
      if (res.respCode === "0000" && detail3.value) {
        existRelation.value = detail3.value.count > 0;
        // console.log("existRelation.value", existRelation.value);
      } else {
        // message.error(res.respDesc);
      }
    };
    const existassuringReturnRelationOrNot = async () => {
      const { bizId, bizType } = props;
      let res = await runDetail4(bizId);
      if (res.respCode === "0000" && detail4.value) {
        existRelation.value = detail4.value.count > 0;
        // console.log("existRelation.value", existRelation.value);
      } else {
        // message.error(res.respDesc);
      }
    };
    const onLoading = (value) => {
      state.loading = value;
    };
    //查询租赁付款申请的合同是否有对应的对外付款单相关联，如果关联不可作废
    // const existPaymentPage =async () => {
    //   existRelation.value = true
    //   const { bizType,basicInfo,bizId } = props;
    //   // let paymentContractId = basicInfo.paymentContractId;
    //   let res = await runDetail5(bizId);
    //   if (res.respCode === "0000" && detail5.value) {
    //     existRelation.value = detail5.value.count > 0;
    //     // console.log("existRelation.value5", existRelation.value);
    //   }else {

    //   }
    // }
    onMountedOrActivated(async () => {
      await getDetail(true);
      //判断关联条件改为该保证金支付单下有已生效或者未生效，即非作废的保证金退回单，则不允许作废
      //只有保证金页面才调用这个接口 这里缺少保证金判断接口

      //已被对外付款单关联的采购付款申请、分包付款申请、租赁付款申请应该不可作废
      if (
        [
          "purchase_payment_apply_examine",
          "subcontract_payment_apply_examine",
          "lease_payment_apply_examine",
        ].includes(props.bizType)
      ) {
        await existRelationOrNot();
      }
      if (props.bizType === "assuring_money_examine") {
        await existassuringRelationOrNot();
      }
      if (props.bizType === "margin_payment_examine") {
        await existassuringReturnRelationOrNot();
      }
      // if(props.bizType ==="lease_payment_apply_examine"){//查询租赁付款申请的合同是否有对应的对外付款单相关联，如果关联不可作废
      //     await existPaymentPage()
      // }
    });
    let tmp = true;
    if (props.examineAccess && props.examineAccess.length > 0) {
      tmp = store.state.user.buttons[props.examineAccess || ""];
    }
    const showSubmitFlg = computed(() => {
      // // console.log('tmp',tmp,'showSubmitBtn',showSubmitBtn.value)
      return tmp && showSubmitBtn.value;
    });
    const showAgreeFlg = computed(() => {
      return tmp && showAgreeBtn.value;
    });
    const showCancelFlg = computed(() => {
      return tmp && showCancelBtn.value;
    });
    const showRejectFlg = computed(() => {
      return tmp && showRejectBtn.value;
    });
    const showVoidFlg = computed(() => {
      return tmp && showVoidBtn.value;
    });
    return {
      showSubmitBtn,
      showAgreeBtn,
      showRejectBtn,
      showCancelBtn,
      showVoidBtn,
      getDetail,
      ...toRefs(state),
      onLoading,
      existRelation,
      refreshApprovalDetail,
      showSubmitFlg,
      showAgreeFlg,
      showCancelFlg,
      showRejectFlg,
      showVoidFlg,
      notShowVoid,
    };
  },
});
</script>
<style scoped>
.margin-left-14px {
  margin-left: 14px !important;
}
</style>
